import React from "react";
import cn from "classnames";
import { UseFormRegister, FieldValues } from "react-hook-form";

type InputProps = {
  label: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  rows?: number;
};

type Ref = HTMLTextAreaElement;
type Props = InputProps & ReturnType<UseFormRegister<FieldValues>>;

const Text = React.forwardRef<Ref, Props>(
  ({ label, placeholder, className, disabled, rows = 5, ...props }, ref) => {
    // See Input.tsx - this had the same module-scope nanoid() id, shared by every
    // instance. useId gives each textarea its own.
    const id = React.useId();

    return (
      <div className={cn("flex flex-col gap-y-1.5 grow", className && className)}>
        <label htmlFor={id} className="text-slate-600 text-sm font-medium">
          {label}
        </label>
        <textarea
          id={id}
          placeholder={placeholder}
          disabled={disabled}
          {...props}
          ref={ref}
          rows={rows}
          className={cn(
            "rounded-md border border-slate-300 bg-white text-sm px-3 py-2 min-w-0 placeholder:text-slate-400 focus:outline-none focus:border-vg-blue focus:ring-[3px] focus:ring-vg-blue/15 transition-colors",
            disabled && "bg-slate-50 text-slate-500 cursor-not-allowed"
          )}
        ></textarea>
      </div>
    );
  }
);

Text.displayName = "Text";

export default Text;
